// Generated code for Big.Entities.Beroepsgroep.
// Edit _Enum.tst to change the generated output.

export enum Beroepsgroep {
    artsen = 1,
    tandartsen = 2,
    verloskundigen = 3,
    fysiotherapeuten = 4,
    psychotherapeuten = 16,
    apothekers = 17,
    apotheekhoudendeArtsen = 18,
    gzPsychologen = 25,
    verpleegkundigen = 30,
    orthopedagoogGeneralisten = 31,
    regieverpleegkundigen = 32,
    geregistreerdMondhygiënisten = 79,
    bachelorMedischHulpverlener = 80,
    physicianAssistants = 81,
    klinischTechnologen = 82,
    apothekersassistenten = 83,
    klinischeFysici = 84,
    tandprothetica = 85,
    verzorgendenIndividueleGezondheidszorg = 86,
    optometristen = 87,
    huidtherapeuten = 88,
    diëtisten = 89,
    ergotherapeuten = 90,
    logopedisten = 91,
    mondhygiënisten = 92,
    oefentherapeutenMensendieck = 93,
    oefentherapeutenCesar = 94,
    orthoptisten = 95,
    podotherapeuten = 96,
    radiodiagnostischLaboranten = 97,
    radiotherapeutischLaboranten = 98,
    onbekend = 99
}
(Beroepsgroep as any).name = 'Beroepsgroep';
